(function() {
    'use strict';
    
    let blazycounter = 0;
    
    function klazyValidate(elements) {
        elements.forEach(function(element) {
            blazycounter++;
            if (!element.classList.contains('b-loading')) {
                element.classList.add('b-loading');

                // todo add error handling: ele.parentNode.className = ele.parentNode.className+ " b-done b-error-wrapper";
                let img;
                if (element.tagName === 'DIV') {
                    element.style.backgroundImage = 'url("' + element.dataset.src + '")';
                    element.classList.add('b-loader-' + blazycounter);
                    img = document.createElement('img');
                    img.src = element.dataset.src;
                    img.className = 'b-dummy';
                    img.style.cssText = 'width:1px;height:1px;opacity:.001;position:fixed;top:0;left:0;';
                    img.dataset.target = blazycounter;
                    document.body.appendChild(img);
                } else if (element.tagName === 'IMG') {
                    element.src = element.dataset.src;
                    img = element;
                }

                img.addEventListener('load', function() {
                    let targetImg = this;
                    if (this.classList.contains('b-dummy')) {
                        targetImg = document.querySelector('.b-loader-' + this.dataset.target);
                        this.remove();
                    }
                    targetImg.classList.add('b-loaded');
                    if (targetImg.parentNode) {
                        targetImg.parentNode.classList.add('b-done');
                    }
                });
            }
        });
    }

    function initKlazy() {
        const blazy_items = document.querySelectorAll('.klazy');

        if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {

            // Intersection Observer Configuration
            const observerOptions = {
                root: document.getElementById('scroll-main'), // document viewport
                rootMargin: '200px 100% 200px 100%', // document viewport offsets
                threshold: 0 // first and last visible pixel triggers observer
            };
            // Intersection Observer Configuration
            const observerOptionsPopup = {
                root: document.getElementById('scroll-dialog'), // document viewport
                rootMargin: '200px 100% 200px 100%', // document viewport offsets
                threshold: 0 // first and last visible pixel triggers observer
            };

            const observerFunction = function handleIntersect(entries, observer) {
                entries.forEach(function(entry) {
                    const element = entry.target;
                    if (entry.isIntersecting) {
                        if (!element.classList.contains('b-loaded')) {
                            klazyValidate([element]);
                        } else {
                            observer.unobserve(element);
                        }
                    }
                });
            };

            const observer = new IntersectionObserver(observerFunction, observerOptions);
            const observerPopup = new IntersectionObserver(observerFunction, observerOptionsPopup);

            blazy_items.forEach(function(item) {
                observer.observe(item);
                observerPopup.observe(item);
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        initKlazy();
    });

})();